"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const getIconByType = type => {
  switch (type) {
    case 'info':
      return /*#__PURE__*/_react.default.createElement("i", {
        className: "fa-solid fa-circle-info"
      });
    case 'success':
      return /*#__PURE__*/_react.default.createElement("i", {
        className: "fa-solid fa-check"
      });
    case 'warn':
      return /*#__PURE__*/_react.default.createElement("i", {
        className: "fa-solid fa-triangle-exclamation"
      });
    case 'error':
      return /*#__PURE__*/_react.default.createElement("i", {
        className: "fa-solid fa-xmark"
      });
    default:
      return null;
  }
};

/**
 * The Notice component is used to display an informational message to the user.
 */
const Notice = _ref => {
  let {
    label,
    title,
    type,
    className,
    children,
    ...attributes
  } = _ref;
  const classes = (0, _clsx.default)('uk-notice', "uk-notice--" + type, className);
  const icon = getIconByType(type);
  const text = label || children;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes
  }, attributes), icon && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-notice__icon"
  }, icon), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-notice__content"
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-notice__title"
  }, title), text && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-notice__text"
  }, text)));
};
Notice.propTypes = {
  /**
   * Type of the Notice
   */
  type: _propTypes.default.oneOf(['info', 'success', 'warn', 'error']),
  /**
   * Title of the Notice
   */
  title: _propTypes.default.string,
  /**
   * Content of the Notice
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element])
};
Notice.defaultProps = {
  type: 'info'
};
var _default = exports.default = Notice;